Fancybox.bind('[data-fancybox]', {
    animated: false,
});